export const TABLE_QR_LIST_SUCCESS = 'TABLE_QR_LIST_SUCCESS';
export const CREATE_TABLE_QR_SUCCESS = 'CREATE_TABLE_QR_SUCCESS';
export const EDIT_TABLE_QR_SUCCESS = 'EDIT_TABLE_QR_SUCCESS';
export const DELETE_TABLE_QR_SUCCESS = 'DELETE_TABLE_QR_SUCCESS';
